export default __webpack_public_path__ + "static/media/english-card-bg.6dd4c167.svg";